import { IJsonQuery } from '../../../packages/api-models/common/json_query';
import { setTerm } from './helpers';

export const setBuilderId = setTerm('builder' as unknown as keyof IJsonQuery);
